import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { Menu, X, LayoutDashboard, LogOut, ShieldCheck } from "lucide-react";

const NAV = [
  { to: "/how-it-works", label: "How It Works" },
  { to: "/pricing", label: "Pricing" },
  { to: "/about", label: "About" },
  { to: "/faq", label: "FAQ" },
  { to: "/contact", label: "Contact" },
];

export const Navbar = () => {
  const { user, logout } = useAuth();
  const [open, setOpen] = useState(false);
  const navigate = useNavigate();

  const handleLogout = async () => {
    await logout();
    navigate("/");
  };

  return (
    <header className="glass-header sticky top-0 z-50">
      <div className="max-w-7xl mx-auto px-5 sm:px-8 h-16 flex items-center justify-between">
        <Link to="/" className="flex items-center gap-2.5" data-testid="brand-logo">
          <span className="inline-block w-2.5 h-2.5 bg-gold rotate-45" aria-hidden="true" />
          <span className="font-display font-bold text-navy text-lg tracking-tight">FundReady Lab</span>
        </Link>

        <nav className="hidden lg:flex items-center gap-8">
          {NAV.map((n) => (
            <Link key={n.to} to={n.to} data-testid={`nav-${n.label.toLowerCase().replace(/ /g, "-")}`}
              className="text-sm text-charcoal/80 hover:text-navy transition-colors font-medium">
              {n.label}
            </Link>
          ))}
        </nav>

        <div className="hidden lg:flex items-center gap-3">
          {user && user.role === "admin" && (
            <Link to="/admin" data-testid="nav-admin" className="text-sm text-navy font-semibold flex items-center gap-1.5">
              <ShieldCheck size={16} /> Admin
            </Link>
          )}
          {user ? (
            <>
              <Link to="/dashboard" data-testid="nav-dashboard" className="text-sm font-medium text-navy flex items-center gap-1.5">
                <LayoutDashboard size={16} /> Dashboard
              </Link>
              <button onClick={handleLogout} data-testid="nav-logout" className="text-sm text-charcoal/70 hover:text-navy flex items-center gap-1.5">
                <LogOut size={16} /> Log out
              </button>
            </>
          ) : (
            <Link to="/login" data-testid="nav-login" className="text-sm font-medium text-navy">Log in</Link>
          )}
          <Link to="/assessment/new" data-testid="nav-start-assessment"
            className="btn-gold text-sm font-semibold px-5 py-2.5 rounded-[3px]">
            Check Your Funding Readiness
          </Link>
        </div>

        <button className="lg:hidden text-navy" onClick={() => setOpen(!open)} data-testid="mobile-menu-toggle" aria-label="Menu">
          {open ? <X /> : <Menu />}
        </button>
      </div>

      {open && (
        <div className="lg:hidden bg-ivory border-t border-line px-5 py-4 space-y-3 animate-fade-in">
          {NAV.map((n) => (
            <Link key={n.to} to={n.to} onClick={() => setOpen(false)} className="block text-charcoal font-medium py-1">{n.label}</Link>
          ))}
          <div className="pt-3 border-t border-line flex flex-col gap-3">
            {user && user.role === "admin" && <Link to="/admin" onClick={() => setOpen(false)} className="text-navy font-semibold">Admin</Link>}
            {user ? (
              <>
                <Link to="/dashboard" onClick={() => setOpen(false)} className="text-navy font-medium">Dashboard</Link>
                <button onClick={handleLogout} className="text-left text-charcoal/70">Log out</button>
              </>
            ) : (
              <Link to="/login" onClick={() => setOpen(false)} className="text-navy font-medium">Log in</Link>
            )}
            <Link to="/assessment/new" onClick={() => setOpen(false)} className="btn-gold text-center font-semibold px-5 py-2.5 rounded-[3px]">Check Your Funding Readiness</Link>
          </div>
        </div>
      )}
    </header>
  );
};
